<div class="row no-gutters" *ngIf="address">
    <div class="col-sm-8" style="padding-right: 25px;">
        <mat-form-field class="full-width">
            <mat-label>{{ address.trans.street | translate }}</mat-label>
            <input id="{{idPrefix}}input_text.{{address.trans.street}}"
                   type="text" matInput
                   [(ngModel)]="address.street"
                   (blur)="onChange()"
                   [disabled]="disabled">
        </mat-form-field>
    </div>

    <div class="col-sm-4">
        <mat-form-field class="full-width">
            <mat-label>{{ address.trans.number | translate }}</mat-label>
            <input id="{{idPrefix}}input_text.{{address.trans.number}}"
                   type="text" matInput
                   [(ngModel)]="address.number"
                   (blur)="onChange()"
                   [disabled]="disabled">
        </mat-form-field>
    </div>
</div>

<div class="row no-gutters" *ngIf="address">
    <div class="col-sm-4" style="padding-right: 25px;">
        <mat-form-field class="full-width">
            <mat-label>{{ address.trans.postalcode | translate }}</mat-label>
            <input id="{{idPrefix}}input_text.{{address.trans.postalcode}}"
                   type="text" matInput
                   [(ngModel)]="address.postalcode"
                   (blur)="onChange()"
                   [disabled]="disabled">
        </mat-form-field>
    </div>

    <div class="col-sm-8">
        <mat-form-field class="full-width">
            <mat-label>{{ address.trans.city | translate }}</mat-label>
            <input id="{{idPrefix}}input_text.{{address.trans.city}}"
                   type="text" matInput
                   [(ngModel)]="address.city"
                   (blur)="onChange()"
                   [disabled]="disabled">
        </mat-form-field>
    </div>
</div>

<div class="row no-gutters" *ngIf="address">
    <div class="col-sm-12">
        <country-select class="full-width"
                        [selectedId]="address.getCountryPropertyCode || address.countryCode"
                        (multiUpdated)="onCountryChange($event)"
                        [idPrefix]="idPrefix"
                        [idSuffix]="address.trans.country"
                        [disabled]="disabled">
        </country-select>
    </div>
</div>
